import _slicedToArray from '../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { ThemeConstellation, Flex, Divider, Spacer } from '@zillow/constellation';
import { useState, useEffect } from 'react';
import Header from './Header.js';
import CalculatorForm from './CalculatorForm.js';
import { ENV } from './constants.js';
import { initCalculatorConfigs } from './configs.js';
import { CalculatorContext } from './useCalculatorContext.js';
import SecondaryCta from './outputs/SecondaryCta.js';
import jsxRuntime from '../../node_modules/react/jsx-runtime.js';

var AffordabilityCalculator = function AffordabilityCalculator(_ref) {
  var env = _ref.env,
    debug = _ref.debug;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    outputs = _useState2[0],
    updateOutputs = _useState2[1];
  useEffect(function () {
    initCalculatorConfigs(env);
  }, [env]);
  useEffect(function () {
    if (debug) {
      // eslint-disable-next-line no-console
      outputs && console.info(JSON.stringify(outputs, null, 2));
    }
  }, [debug, outputs]);
  return /*#__PURE__*/jsxRuntime.jsx(ThemeProvider, {
    theme: ThemeConstellation,
    children: /*#__PURE__*/jsxRuntime.jsxs(CalculatorContext.Provider, {
      value: {
        outputs: outputs,
        updateOutputs: updateOutputs
      },
      children: [/*#__PURE__*/jsxRuntime.jsxs(Flex, {
        display: "flex",
        flexDirection: "column",
        children: [/*#__PURE__*/jsxRuntime.jsx(Header, {}), /*#__PURE__*/jsxRuntime.jsx(Divider, {
          marginY: "md"
        }), /*#__PURE__*/jsxRuntime.jsx(CalculatorForm, {})]
      }), (outputs === null || outputs === void 0 ? void 0 : outputs.outcome) && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [/*#__PURE__*/jsxRuntime.jsx(Spacer, {
          marginTop: "xl"
        }), /*#__PURE__*/jsxRuntime.jsx(SecondaryCta, {
          outputs: outputs
        })]
      })]
    })
  });
};
AffordabilityCalculator.propTypes = {
  env: PropTypes.oneOf(Object.values(ENV)).isRequired,
  debug: PropTypes.bool
};
AffordabilityCalculator.defaultProps = {
  debug: false
};
AffordabilityCalculator.ENV = ENV;
var AffordabilityCalculator$1 = AffordabilityCalculator;

export { AffordabilityCalculator$1 as default };
//# sourceMappingURL=AffordabilityCalculator.js.map
